/* eslint-disable */
// prettier-ignore
import store from '@/store/app'

// Create reusable route function inside the same file
function buildRoute(name) {
  const agent = store.state.agent
  if (agent && agent !== '1dbaa403b94ccdd1991c3afd511858a5') {
    return { name, query: { agent } }
  }
  return { name }
}

export default {
  pages: {
    key: 'title',
    data: [
      { title: 'Landing Page', route: buildRoute('landing'), icon: 'ShieldIcon', isBookmarked: false },
      { title: 'Quotation', route: buildRoute('quotation'), icon: 'TypeIcon', isBookmarked: false },
      { title: 'Payments', route: buildRoute('payments'), icon: 'CreditCardIcon', isBookmarked: false },
      { title: 'Terms of Use', route: buildRoute('terms'), icon: 'InfoIcon', isBookmarked: false },
      { title: 'Privacy Policy', route: buildRoute('privacy'), icon: 'InfoIcon', isBookmarked: false },
      { title: 'About Us', route: buildRoute('about'), icon: 'HeartIcon', isBookmarked: false },
      { title: 'Contact Us', route: buildRoute('contact'), icon: 'ActivityIcon', isBookmarked: false },
      { title: 'Affiliate Program', route: buildRoute('affiliate'), icon: 'BoldIcon', isBookmarked: false },
      { title: 'Products', route: buildRoute('products'), icon: 'BoldIcon', isBookmarked: false },
      { title: 'Offers', route: buildRoute('offers'), icon: 'BoldIcon', isBookmarked: false },
    ],
  },
}
/* eslint-enable */
